import type { PipelineRunState } from '@/types/api';

const TERMINAL_RUN_STATES: ReadonlySet<PipelineRunState> = new Set<PipelineRunState>([
  'completed',
  'failed'
]);

export function isTerminalRunState(state: PipelineRunState | undefined): boolean {
  return state !== undefined && TERMINAL_RUN_STATES.has(state);
}

export function isLiveRunState(state: PipelineRunState | undefined): boolean {
  return state !== undefined && !TERMINAL_RUN_STATES.has(state);
}
